import { of as observableOf, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import CountyStateFIPS from '@app/models/county-state-fips';
import StateFIPS from '@app/models/state-fips';
import County from '@app/models/county';

@Injectable({
  providedIn: "root"
})
export class AdministrativeBoundaryService {
  private readonly _componentName = 'AdministrativeBoundaryService';

  constructor(private http: HttpClient) {}

  public getCounties(stateAbbreviation: string) {
    return this.http.get<CountyStateFIPS[]>(`locality/state/${stateAbbreviation}/county`);
  }

  public getCountiesFromStateFIPSCode(stateFips: string) {
    return this.http.get<County[]>(`locality/countiesFromStateFIPS/${stateFips}`);
  }

  public getStates() {
    return this.http.get<StateFIPS[]>(`locality/states`);
  }

  public getStateId(state: string): Observable<string> {
    return this.http.get<string>(`search/stateId/${state}`);
  }

  public getStateAbbr(stateId: number) {
    return this.http.get(`search/stateAbbr/${stateId}`);
  }

  public getCountyName(stateId: number, countyId: number) {
    return this.http.get(`search/county/${stateId}/${countyId}`);
  }

  public getCountyId(stateId: number, countyName: string): Observable<string> {
    return this.http.get<string>(`search/countyId/${stateId}/${countyName}`);
  }

  
}
